import { createSlice, Slice } from '@reduxjs/toolkit';
import { API_URL } from 'constants/settings';
import { User } from './types';

export const initUser: User = {
  username: '',
  passwordChanged: false,
  isAuth: false,
  role: '',
  tokens: { access: null, refresh: null },
  theme: 'light',
  lang: 'en',
  apiUrl: API_URL,
};

const userSlice: Slice<User> = createSlice({
  name: 'user',
  initialState: initUser,
  reducers: {
    setAuth: (state, { payload }) => {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
    toggleTheme: (state) => {
      state.theme = state.theme === 'dark' ? 'light' : 'dark';
    },
    changeLang: (state, { payload }) => {
      state.lang = payload.lang;
    },
    logout: (state) => {
      const tempInitUser = { ...initUser };
      delete tempInitUser.theme;
      delete tempInitUser.lang;

      Object.keys(tempInitUser).forEach((key) => {
        state[key] = initUser[key];
      });
      state.cashierPermissions = undefined;
    },
  },
});

export const { setAuth, toggleTheme, logout, changeLang } = userSlice.actions;
export default userSlice.reducer;
